const { h, render, Component } = require('preact');
const {route} = require('preact-router')

class BreadcrumbItem extends Component {
    constructor(props) {
      super(props)
      this.clickCrumbItem = this.clickCrumbItem.bind(this);
    }

    clickCrumbItem()
    {
      route(this.props.url)
      this.props.handleCrumbClick({'text': this.props.text, 'url': this.props.url})
    }


    render() {
      return (
              <li onClick={(e) => {
                e.preventDefault()
                this.clickCrumbItem()}
                }>
                <a href="">
                  <span>{this.props.text}</span>
                </a>
              </li>
      )
    }
}

module.exports = BreadcrumbItem
